import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Gallery.css';

const Gallery: React.FC = () => {
  const navigate = useNavigate();

  const handleRequestArt = () => {
    navigate('/form');
  };

  const artworkExamples = [
    {
      id: 1,
      title: "unicorn",
      description: "a majestic talking unicorn",
      image: "/images/unicorn.jpeg",
    },
    {
      id: 2,
      title: "easter bunny",
      description: "the easter bunny on his annual egg-delivery rounds",
      image: "/images/easter-bunny.jpeg",
    },
    {
      id: 3,
      title: "nashville",
      description: "a scenic shot of the nashville skyline",
      image: "/images/nashville.jpeg",
    },
  ];

  return (
    <div className="gallery-page">
      <div className="gallery-header">
        <h1>doodle gallery</h1>
      </div>

      <div className="gallery-grid">
        {artworkExamples.map((artwork) => (
          <div key={artwork.id} className="artwork-card">
            <div className="artwork-image">
              <img src={artwork.image} alt={artwork.title} className="artwork-img" />
            </div>
            <div className="artwork-info">
              <h3>{artwork.title}</h3>
              <p>{artwork.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="gallery-cta">
        <p>like our gallery? want to request a doodle?</p>
        <button className="cta-button" onClick={handleRequestArt}>Request a doodle</button>
      </div>
    </div>
  );
};

export default Gallery; 